module.exports = __webpack_public_path__ + "static/media/launch_beach_marker.c5352e70.svg";